exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".skeleton {\n    height: 100%;\n    width: 100%;\n    border-radius: 4px;\n    background-size: cover;\n  background: linear-gradient(270deg, #f0f0f5, white);\n  background-size: 400% 400%;\n  animation: loading 2s ease infinite;\n  }\n  @keyframes loading { \n      0%{background-position:0% 50%}\n      50%{background-position:100% 50%}\n      100%{background-position:0% 50%}\n  }\n  \n  .skeleton-l {\n    height: 30;\n  }\n  \n  .skeleton-m {\n    height: 15px;\n  }\n  \n  .skeleton-box {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    width: -moz-available;\n    width: stretch;\n  }\n  \n  .skeleton-box .fullWidth {\n    -ms-flex: 1 1 auto;\n        flex: 1 1 auto;\n  }\n  \n  .footer {\n    position: unset;\n    background-color: inherit;\n  }\n  \n  .skeleton-s {\n    height: 10px;\n  }\n  \n  .skeleton-xl {\n    height: 15px;\n    background-size: cover;\n  }\n  \n  div[class*='skeleton-'] {\n    margin: 5;\n  }\n  \n  .fill-gray {\n    height: 100%;\n    width: 100%;\n    border-radius: 4px;\n    background-size: cover;\n    background-color: #f0f0f5;\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/material/deliverable-tile-loading/deliverable-tile-loading.component.css
// module id = 182
// module chunks = 0